export default {
  monospace: 'monospace' ,
  system: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
}


// WEBPACK FOOTER //
// ./src/style/font.js